
import AdsApi from '../../libs/ads-request/ads-api';
import { groupByDate } from '../../libs/helpers';
import ERROR_MESSAGES from '../../libs/errorMessages';

export default {
  name: 'NotificationsView',
  data: () => ({
    navigation: [{ text: 'Home', boxIcon: 'home', navigate: 'home' }, { text: 'Notificaciones' }],
    total: 5,
    notifications: [],
    loadError: '',
  }),
  mounted() {
    this.getNotifications();
  },
  methods: {
    getNotifications() {
      this.loaderShow('Obteniendo notificaciones');
      this.loadError = '';

      AdsApi.getNotifications()
        .then((response) => {
          const { data } = response;

          this.notifications = groupByDate(data.notifications);
        })
        .catch(() => {
          this.loadError = ERROR_MESSAGES.LOAD_INFO;
        })
        .then(this.loaderHide);
    },
  },
};
